import { lang } from "../../assets/lang"

const instagram_addon = window.xitFlowBuilderData.instagram_addon

export const types = [
  { key: 'new_post_back', value: lang.quick_reply_html_reply_types_newPostback },
  { key: 'post_back', value: lang.quick_reply_html_reply_types_postback },
]

if (! instagram_addon) {
  types.push(
    { key: 'phone', value: lang.quick_reply_html_reply_types_phone }, 
    { key: 'email', value: lang.quick_reply_html_reply_types_email },
  )
}